import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSO = '/saude'
export default {
  buscarEstoqueRemedio,
  buscarEstoqueRemedioPorUnidade,
  buscarEstoquePorRemedioPorUnidade,
  buscarFilaConsolidado,
  buscarFilaPorProcedimento,
  buscarFilaPorEspecialidade,
  buscarFilaDeConsultaPorEspecialidade,
  buscarFilaDeExamePorSubgrupo,
  buscarFilaDeExamePorTipoProcedimentoPorRegiao,
  buscarFilaDeExamePorProcedimentoPorRegiao,
  buscarFilaDeExamePorEspecialidadePorRegiao,
  buscarFilaDeExameProcedimentoPorSubgrupoPorRegiao,
  buscarFilaDeExameHistoricoUltimosMeses,
  buscarFilaDeExameHistoricoRegiao,
  buscarMedicamentosPorFarmacia,
  buscarUnidadesRedeMunicipalPorGrupo,
  filaDeProcedimentoConsolidadoPorClasse,
  filaDeProcedimentoPorProcedimento,
  filaDeProcedimentoPorEspecialidade,
  filaDeProcedimentoPorGrupoDeProcedimentos,
  filaDeProcedimentoDetalhadoPorClasseDeProcedimento,
  filaDeProcedimentoDetalhado,
  quantitativosDeProfissionaisPorQualificador,
}

function buscarEstoqueRemedio () {
  return Api.get(`${RECURSO}/estoqueDeRemedios`)
}

function buscarEstoqueRemedioPorUnidade () {
  return Api.get(`${RECURSO}/estoqueDeRemediosPorUnidade`)
}

function buscarEstoquePorRemedioPorUnidade ({ cnes, idMedicamento }) {
  let params = { 'filtroCnes': cnes, 'filtroIdMedicamento': idMedicamento }
  return Api.get(`${RECURSO}/estoquePorRemedioPorUnidade${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaConsolidado () {
  return Api.get(`${RECURSO}/filaDeExamePorTipoProcedimento`)
}

function buscarFilaPorProcedimento ({ tipoProcedimento, categoria }) {
  let params = { 'tipoProcedimento': tipoProcedimento, 'categoria': categoria }
  return Api.get(`${RECURSO}/filaDeExamePorProcedimento${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaPorEspecialidade () {
  return Api.get(`${RECURSO}/filaDeExamePorEspecialidade`)
}

function buscarFilaDeConsultaPorEspecialidade ({ tipoConsulta }) {
  let params = { 'tipoConsulta': tipoConsulta }
  return Api.get(`${RECURSO}/filaDeExameDeConsultaPorEspecialidade${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExamePorSubgrupo ({ tipoProcedimento, agrupamento }) {
  let params = { 'tipoProcedimento': tipoProcedimento, 'agrupamento': agrupamento }
  return Api.get(`${RECURSO}/filaDeExamePorEspecialidadePorSubgrupo${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExamePorTipoProcedimentoPorRegiao ({ tipoProcedimento }) {
  let params = { 'tipoProcedimento': tipoProcedimento }
  return Api.get(`${RECURSO}/filaDeExamePorTipoProcedimentoPorRegiao${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExamePorProcedimentoPorRegiao ({ tipoProcedimento }) {
  let params = { 'tipoProcedimento': tipoProcedimento }
  return Api.get(`${RECURSO}/filaDeExamePorProcedimentoPorRegiao${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExamePorEspecialidadePorRegiao ({ tipoProcedimento }) {
  let params = { 'tipoProcedimento': tipoProcedimento }
  return Api.get(`${RECURSO}/filaDeExamePorEspecialidadePorRegiao${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExameProcedimentoPorSubgrupoPorRegiao ({ tipoProcedimento }) {
  let params = { 'tipoProcedimento': tipoProcedimento }
  return Api.get(`${RECURSO}/filaDeExameProcedimentoPorSubgrupoPorRegiao${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExameHistoricoUltimosMeses ({ ultimosMeses }) {
  let params = { 'ultimosMeses': ultimosMeses }
  return Api.get(`${RECURSO}/filaDeExameHistoricoUltimosMeses${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarFilaDeExameHistoricoRegiao ({ ultimosMeses }) {
  let params = { 'ultimosMeses': ultimosMeses }
  return Api.get(`${RECURSO}/filaDeExameHistoricoRegiao${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarMedicamentosPorFarmacia ({ filtroCnes, filtroMedicamento }) {
  let params = { 'filtroCnes': filtroCnes, 'filtroMedicamento': filtroMedicamento }
  return Api.get(`${RECURSO}/estoquePorRemedioPorUnidade${MetodosGlobais.createEncodeQuery(params)}`)
}

function buscarUnidadesRedeMunicipalPorGrupo () {
  return Api.get(`${RECURSO}/unidadesRedeMunicipalPorGrupo`)
}

function filaDeProcedimentoConsolidadoPorClasse ({ classeProcedimento }) {
  let params = { 'classeProcedimento': classeProcedimento }
  return Api.get(`${RECURSO}/filaDeProcedimentoConsolidadoPorClasse${MetodosGlobais.createEncodeQuery(params)}`)
}

function filaDeProcedimentoPorProcedimento ({ classeProcedimento }) {
  let params = { 'classeProcedimento': classeProcedimento }
  return Api.get(`${RECURSO}/filaDeProcedimentoPorProcedimento${MetodosGlobais.createEncodeQuery(params)}`)
}

function filaDeProcedimentoPorGrupoDeProcedimentos ({ classeProcedimento }) {
  let params = { 'classeProcedimento': classeProcedimento }
  return Api.get(`${RECURSO}/filaDeProcedimentoPorGrupoDeProcedimentos${MetodosGlobais.createEncodeQuery(params)}`)
}

function filaDeProcedimentoDetalhadoPorClasseDeProcedimento ({ classeProcedimento }) {
  let params = { 'classeProcedimento': classeProcedimento }
  return Api.get(`${RECURSO}/filaDeProcedimentoDetalhadoPorClasseDeProcedimento${MetodosGlobais.createEncodeQuery(params)}`)
}

function filaDeProcedimentoDetalhado ({ classeProcedimento }) {
  let params = { 'classeProcedimento': classeProcedimento }
  return Api.get(`${RECURSO}/filaDeProcedimentoDetalhado${MetodosGlobais.createEncodeQuery(params)}`)
}

function filaDeProcedimentoPorEspecialidade ({ classeProcedimento }) {
  let params = { 'classeProcedimento': classeProcedimento }
  return Api.get(`${RECURSO}/filaDeProcedimentoPorEspecialidade${MetodosGlobais.createEncodeQuery(params)}`)
}

function quantitativosDeProfissionaisPorQualificador ({ qualificador }) {
  let params = { 'qualificador': qualificador }
  return Api.get(`${RECURSO}/quantitativosDeProfissionaisPorQualificador${MetodosGlobais.createEncodeQuery(params)}`)
}
